import Weather from '../weather.js';
import Clock from '../clock.js';
import Bottom from '../bottom.js';
import LastVisitLocation from '../navigation.js';

function App() {
  return (
    <>
    <div className="h-faweaz">
      <LastVisitLocation />
        <main className="h-lesaq">
          <div className='main-header-content'>
            <Clock />
            <p className='t-fasdwqe'>Istanbul, Turkey</p>
            <div>
              <Weather />
            </div>
          </div>                              
          <div className='gradient-blob'></div>
          <div className='main-copy-content'>
            <p className='main-copy-content-text'>
              <span className='gray-text'>karabulut, göktuğ.</span> creating
              <svg className="inline-icon" width="24px" height="24px" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" color="currentColor">
                <path d="M21 7.353v9.294a.6.6 0 01-.309.525l-8.4 4.666a.6.6 0 01-.582 0l-8.4-4.666A.6.6 0 013 16.647V7.353a.6.6 0 01.309-.524l8.4-4.667a.6.6 0 01.582 0l8.4 4.667a.6.6 0 01.309.524z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M3.528 7.294l8.18 4.544a.6.6 0 00.583 0l8.209-4.56M12 21v-9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
              software that makes people feel something. design engineer
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="inline-icon">  
                <path d="M10.5 16.5L7 15M2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M8.5 9C8.36739 9 8.24021 8.94732 8.14645 8.85355C8.05268 8.75979 8 8.63261 8 8.5C8 8.36739 8.05268 8.24021 8.14645 8.14645C8.24021 8.05268 8.36739 8 8.5 8C8.63261 8 8.75979 8.05268 8.85355 8.14645C8.94732 8.24021 9 8.36739 9 8.5C9 8.63261 8.94732 8.75979 8.85355 8.85355C8.75979 8.94732 8.63261 9 8.5 9ZM15.5 9C15.3674 9 15.2402 8.94732 15.1464 8.85355C15.0527 8.75979 15 8.63261 15 8.5C15 8.36739 15.0527 8.24021 15.1464 8.14645C15.2402 8.05268 15.3674 8 15.5 8C15.6326 8 15.7598 8.05268 15.8536 8.14645C15.9473 8.24021 16 8.36739 16 8.5C16 8.63261 15.9473 8.75979 15.8536 8.85355C15.7598 8.94732 15.6326 9 15.5 9Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
              unsatisfiably curious about nove/interfaces. currently at <a href="https://www.wppproduction.com/" target="_blank" rel="noopener noreferrer" className="c-bFaGyl gray-text">wPP Production</a>.
            </p>
          </div>         
        </main>   
        <Bottom />
    </div>
    </>
  );
}

export default App;